/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import * as React from 'react'
import classnames from 'classnames'
import { Button, Typography } from '@prom/web-embers'
import tracker, { AccountMethod } from '../../services/mixpanelService'

interface ThirdPartyButtonProps {
  className?: string
  disabled?: boolean
  align?: 'vertical' | 'row'
  method: AccountMethod
  text: string
  icon: string
  url: string
  type: 'login' | 'create'
}

const ThirdPartyButton = (props: ThirdPartyButtonProps) => {
  const { className, method, text, icon, url, align = 'row', disabled, type } = props

  return align === 'row' ? (
    <Button
      fullWidth
      level="secondary"
      size="large"
      colorTheme="grey"
      drawingStyle="outlined"
      startIcon={<img width="24" height="24" src={icon} alt="" />}
      className={classnames('third-party-btn', className)}
      onClick={
        !disabled
          ? () => {
              type === 'create' ? tracker.createAccountStart(method) : tracker.signInStart(method)
              window.location.assign(url)
            }
          : undefined
      }
    >
      {text}
    </Button>
  ) : (
    <a key={method} className={classnames('ThirdPartyButton-vertical', className)} href={!disabled ? url : undefined}>
      <img width="24" height="24" src={icon} alt="" />
      <Typography variant="body">{text}</Typography>
    </a>
  )
}

export default ThirdPartyButton
